import { useState, type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'

import { isNotNull } from '@hcr/utils'

import { AccountEditSearchParamsKeys } from '../../../../../models'
import { InfoMessageFloating } from '../../../../common'

export const UpdateEmailStatusMessage: FC = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const statusSearchParam = searchParams.get(AccountEditSearchParamsKeys.Status)

  const [isInfoMessageShow, setShowInfoMessage] = useState(isNotNull(statusSearchParam))
  const handleCloseInfoMessage = () => setShowInfoMessage(false)

  return (
    <InfoMessageFloating
      variant={statusSearchParam === 'success' ? 'success' : 'error'}
      message={statusSearchParam === 'success' ? t('account.changes-saved') : t('account.changes-could-not-be-updated')}
      isOpen={isInfoMessageShow}
      onClose={handleCloseInfoMessage}
    />
  )
}
